import React, { Component } from "react";
import { withRouter, Link} from "react-router-dom";
import { connect } from 'react-redux';
import { exibeMensagemSucesso, exibeMensagemErro, limpaMensagem, saveState, deleteState, mostraAguardando, escondeAguardando } from "../../providers/actions";
import { Message } from "../Message/Message";
import { Loading } from "../Loading/Loading";
import { Pagination } from "../Pagination/Pagination";
import { ButtonBack } from "../Button/Back";
import {formataData, formataDataMesAno} from '../../utils/formatadorData';
import api from "../../services/api";
import './Contract.css';
import DatePicker , { registerLocale } from "react-datepicker";
import pt_br from "date-fns/locale/pt-BR";
import "react-datepicker/dist/react-datepicker.css";
import { ConfirmModal } from "../ConfirmModal/ConfirmModal";
import { getMessagemErro } from "../../utils/erro";
import { ContractDetails } from "./ContractDetails";

const mapDispatchToProps = { saveState, deleteState, exibeMensagemSucesso, exibeMensagemErro, limpaMensagem, mostraAguardando, escondeAguardando }

const mapStateToProps = (state) => {
	return {
		user: state.usuarioStore.user,
		filters: state.filterStore,
	}
}

registerLocale("pt_br", pt_br);

export const BillingReferenceList =

// router
withRouter(
// redux
connect(
	(mapStateToProps), 
	(mapDispatchToProps)
)(
	class extends Component {
	
		constructor(props){
			super(props);
			const idContrato = this.props.match.params.id;

			this.initialState = {
				contrato: {},
				criterioPesquisa: {
					idContrato,
					referencia: '',
					periodoInicial: '',
					periodoFinal: '',
				},
				resultadoPesquisa: {},
				pesquisaExecutada: false,
				exibeModalAtivar: false,
				exibeModalInativar: false,
				exibeModalConfirmacao: false,
				botoesHabilitados : true,
				edicaoPermitida: false,
		 	};

			this.state = this.initialState;
			this.handleInputChange = this.handleInputChange.bind(this);
			this.pesquisar = this.pesquisar.bind(this);
			this.limparPesquisa = this.limparPesquisa.bind(this);
			this.executaPesquisaPaginada = this.executaPesquisaPaginada.bind(this);
			this.confirmaOperacao = this.confirmaOperacao.bind(this);
			this.excluirItem = this.excluirItem.bind(this);
		}

		render() {
			return (
				<main id="content" className="page-content p-3">
					<Message />
					<Loading />
					
					<div style={{margin: "10px"}}>
						<h1>Cadastro de Contrato - Referências de Faturamento</h1>
					</div>
					
					<div className="div-form">
						{this.renderForm()}
					</div>
				</main>
			);
		}

		componentDidMount(){
			this.props.limpaMensagem();
			const id = this.props.match.params.id;
			const user = this.props.user;

			if(id){
				const criterioPesquisa = this.state.criterioPesquisa;
				criterioPesquisa['idContrato'] = id;

				api.get(`/api/contrato/${id}`)
					.then(response => { 
						const contrato = response.data;
						const edicaoPermitida = (user.isAdministrador === true && contrato.contratoSerpro === false) || (user.isMantenedor === true  && contrato.contratoSerpro === true);

						this.setState(prevState => ({ ...prevState, contrato, edicaoPermitida}))
					})
					.catch(erro => {
						console.log("Não foi possível recuperar o contrato " + erro)
						this.props.exibeMensagemErro("Erro durante o carregamento da página")
					});
			}

			this.executaPesquisaPaginada();

		}
		
		renderForm() {
			const { criterioPesquisa, resultadoPesquisa, pesquisaExecutada, edicaoPermitida } = this.state;
			const { referencia, periodoInicial, periodoFinal,} = criterioPesquisa;
			const { content } = resultadoPesquisa;

			return(
				<div className="container-fluid">
					<ConfirmModal titulo="Confirmação" 
						visible={this.state.exibeModalConfirmacao}
						handleOk={() => this.executaOperacao()}
						handleCancel={() => this.fechaModal()}
						message={this.state.msgModal}/>

					<div className="br-form">
						<ContractDetails contrato={this.state.contrato} />
						
						<fieldset>
							<legend>Referências de Faturamento Cadastradas</legend>

							<div className="row">
								<div className="col-md">
									<div className="field">
										<div className="input">
											<label htmlFor="referencia">Mês de Referência:</label>
											<DatePicker id="referencia" locale="pt_br" dateFormat="MM/yyyy" 
												showMonthYearPicker 
												selected={referencia} 
												onChange={data => {
													const criterioPesquisa = this.state.criterioPesquisa;
													criterioPesquisa['referencia'] = data;
													this.setState(prevState => ({ ...prevState, criterioPesquisa}))}
												} />
										</div>
									</div>
								</div>

								<div className="col-md">
									<div className="field">
										<div className="input">
											<label htmlFor="periodoInicial">Período inicial:</label>
											<DatePicker id="periodoInicial" locale="pt_br" dateFormat="dd/MM/yyyy" 
												selected={periodoInicial} 
												onChange={data => {
													const criterioPesquisa = this.state.criterioPesquisa;
													criterioPesquisa['periodoInicial'] = data;
													this.setState(prevState => ({ ...prevState, criterioPesquisa}))}
												} />
										</div>
									</div>
								</div>
								<div className="col-md">
									<div className="field">
										<div className="input">
											<label htmlFor="periodoFinal">Período Final:</label>
											<DatePicker id="periodoFinal" locale="pt_br" dateFormat="dd/MM/yyyy" 
												selected={periodoFinal} 
												onChange={data => {
													const criterioPesquisa = this.state.criterioPesquisa;
													criterioPesquisa['periodoFinal'] = data;
													this.setState(prevState => ({ ...prevState, criterioPesquisa}))}
												} />
										</div>
									</div>
								</div>
							</div>

							<div className="actions-button">
								<div className="actions justify-content-start">
									<button type="button" className="button is-primary" onClick={() => this.pesquisar()} disabled={!this.state.botoesHabilitados}>Pesquisar</button>
									<button type="button" className="button is-secondary" onClick={() => this.limparPesquisa()} disabled={!this.state.botoesHabilitados}>Limpar</button>
									{ edicaoPermitida &&
										<Link to={`/billing-reference/${criterioPesquisa.idContrato}/new`}> 
											<button type="button" className="button is-secondary mr-3" disabled={!this.state.botoesHabilitados}>Novo</button>
										</Link>
									}	
									<ButtonBack disabled={!this.state.botoesHabilitados} />
								</div>
							</div>
					
						
							{(content && content.length > 0) &&	
								<div className="br-table">						
									<div className="table">
										<table>
											<thead>
												<tr>
												<th scope="col">Mês de Referência</th>
												<th scope="col">Período Inicial</th>
												<th scope="col">Período Final</th>
												{ edicaoPermitida &&
													<th className="text-center" scope="col">Ações</th>
												}
												</tr>
											</thead>
											
											<tbody>
												{ content.map((referenciaFaturamento, index) => {
													const edicaoPermitida = this.isEdicaoPermitida(referenciaFaturamento);
													return (
														<tr key={index} >
															<td>{formataDataMesAno(referenciaFaturamento.referencia)}</td>
															<td>{formataData(referenciaFaturamento.periodoInicial)}</td>
															<td>{formataData(referenciaFaturamento.periodoFinal)}</td>
															{ edicaoPermitida &&
																<td className="text-center">
																	<div className="actions">
																		{ edicaoPermitida &&
																			<Link to={`/billing-reference/${referenciaFaturamento.idContrato}/edit/${referenciaFaturamento.id}`}>
																				<button type="button" disabled={!this.state.botoesHabilitados} title="Editar a referência de faturamento">
																					<span className="sr-only">Editar</span>
																					<i className="fas fa-edit"></i>
																				</button>
																			</Link>
																		}
																		{ edicaoPermitida && referenciaFaturamento.permiteExclusao &&
																			<button type="button" 
																				disabled={!this.state.botoesHabilitados || !referenciaFaturamento.permiteExclusao} 
																				onClick={() => this.confirmaOperacao(referenciaFaturamento, this.excluirItem, "Deseja realmente remover a referência de faturamento?")} 
																				title="Excluir a referência de faturamento">
																					
																				<span className="sr-only">Excluir</span>
																				<i className="fas fa-trash" id="danger"></i>
																			</button>
																		}
																	</div>
																</td>
															}
														</tr>
												)})}
											</tbody>
										</table>
										<Pagination totalPaginas={resultadoPesquisa.totalPages} paginaAtual={resultadoPesquisa.number} onChangePage={this.executaPesquisaPaginada}/>
									</div>
								</div>
							}

							{(pesquisaExecutada && (! content || content.length === 0)) &&
								<div>
									Nenhuma referência de faturamento para o contrato com os critérios informados.
								</div>
							}
						</fieldset>
					</div>
				</div>
			);
		}

		isEdicaoPermitida(referenciaFaturamento) {
			const user = this.props.user;
			return (user.isAdministrador === true && referenciaFaturamento.contratoSerpro === false) || (user.isMantenedor === true  && referenciaFaturamento.contratoSerpro === true) 
		}

		handleInputChange(evento){
			const target = evento.target;
			const nome = target.name;
			const valor = target.type === 'checkbox' ? target.checked : target.value;

			const criterioPesquisa = this.state.criterioPesquisa;
			criterioPesquisa[nome] = valor;
			this.setState(prevState => ({ ...prevState,  criterioPesquisa }));
		}

		executarPesquisaAnterior () {
			const lastState = this.props.filters[this.props.location.pathname];

			this.setState(prevState => ({ ...prevState, 
				 ...this.initialState,
				 ...lastState,
				 pesquisaExecutada: false,
				 resultadoPesquisa: {}
			}), () => {
				if (lastState) {
					const lastPage = lastState ? lastState?.resultadoPesquisa?.number : 0;
					this.executaPesquisaPaginada(lastPage);
				}
			});			
		}

		pesquisar (e){
			this.props.limpaMensagem();
			this.executaPesquisaPaginada(0);
			if (this.props.location.state?.resetSearch) {
				this.props.history.replace(this.props.location.pathname, {
					...this.props.location.state,
					resetSearch: false,
				  });
			}
		}

		executaPesquisaPaginada (pagina){

			const {criterioPesquisa} = this.state;
			criterioPesquisa['pagina'] = pagina;
			const url = `/api/referencia-faturamento/${criterioPesquisa.idContrato}/paginado`;

			const options = {
				method: 'post',
				url,
				data: criterioPesquisa
			}

			this.props.mostraAguardando();
			api(options)
				.then(response => { 
					this.setState(prevState => ({ ...prevState, 
						resultadoPesquisa: response.data,
						pesquisaExecutada : true,
					}), () => {
						this.props.saveState(this.state, this.props.location.pathname);
					}) 
				})
				.catch(erro => {
					console.log("Não foi possível recuperar as referências de faturamento. " + erro)
					this.props.exibeMensagemErro("Erro durante a execução da pesquisa")
				})
				.then(() => {
					this.props.escondeAguardando();
				});
		}

		limparPesquisa(){
			const idContrato = this.props.match.params.id;

			this.setState(prevState => ({ ...prevState, 
				criterioPesquisa: {
					idContrato,
					referencia: '',
					periodoInicial: '',
					periodoFinal: '',
				},
				resultadoPesquisa: {},
				pesquisaExecutada: false,
				exibeModalAtivar: false,
				exibeModalInativar: false,
				exibeModalConfirmacao: false,
				botoesHabilitados : true,
			}), () => {
				this.props.deleteState(this.state, this.props.location.pathname);
				this.executaPesquisaPaginada();
			});
		}
	
		fechaModal () {
			this.setState(prevState => ({ ...prevState, exibeModalConfirmacao: false,}));
		}

		confirmaOperacao(item, operacao, msgModal) {
			this.setState(prevState => ({ ...prevState, 
					exibeModalConfirmacao: true,
					itemAlvo: item,
					operacao,
					msgModal,
				}
			));
		}

		executaOperacao () {
			this.setState(prevState => ({ ...prevState, botoesHabilitados:false}));
			this.props.limpaMensagem();
			this.props.mostraAguardando();
			window.scrollTo(0, 0)

			this.state.operacao(this.state.itemAlvo);
			this.fechaModal();
		}

		excluirItem (item){
			api.delete(`/api/referencia-faturamento/${item.id}`)
				.then(response => { 
					this.setState(prevState => ({ ...prevState, pesquisaExecutada : true,}) );
					this.pesquisar();
					this.props.exibeMensagemSucesso("Referência de faturamento excluída com sucesso.");
				})
				.catch(erro => {
					const msg = getMessagemErro("Não foi possível excluir a referência de faturamento.", erro);
					console.log(JSON.stringify(msg));
					this.props.exibeMensagemErro(msg.mensagem, msg.erros);
				})
				.then (() =>{
					this.setState(prevState => ({ ...prevState, botoesHabilitados:true}));
					this.props.escondeAguardando();
				});
		}

	}

) // redux
); // router